import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { ConfirmAction } from "@/components/common";
import { Button } from "@/components/ui/button";

// Creator and Business accounts were retired. Nothing is closed until the admin presses the button.
export const RetiredAccounts = () => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/retired-accounts").then((r) => setD(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const n = d ? d.creator + d.business : 0;
  if (!n) return null;
  const close = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/retired-accounts/close");
      toast.success(`${data.closed} account${data.closed === 1 ? "" : "s"} closed`);
      if (data.failed.length) toast.error(`Couldn't close: ${data.failed.join(", ")}. Try again.`);
      load();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <section className="surface flex flex-wrap items-center gap-3 border-rose-200 p-5" data-testid="retired-accounts">
      <div className="flex-1">
        <h2 className="text-xl">Old Creator & Business accounts</h2>
        <p className="text-sm text-slate-600" data-testid="retired-accounts-count">{d.creator} Creator and {d.business} Business, {n} account{n === 1 ? "" : "s"} in total, still open.{d.admins > 0 && ` ${d.admins === 1 ? "1 belongs to an admin, who" : `${d.admins} belong to admins, who`} just become${d.admins === 1 ? "s a regular account" : " regular accounts"}.`}</p>
      </div>
      <ConfirmAction testid="retired-accounts-close" destructive confirmLabel={`Close ${n}`} title={`Close ${n} account${n === 1 ? "" : "s"}?`} onConfirm={close}
        description="Each person's sign-in, Facts, comments, reactions, messages and other data are permanently deleted. Nobody, including Middle, can restore them."
        trigger={<Button variant="destructive" className="rounded-full" disabled={busy} data-testid="retired-accounts-close-btn">{busy ? "Closing…" : "Close these accounts"}</Button>} />
    </section>
  );
};
